import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const ProjectContext = createContext(null);
export const useProjects = () => useContext(ProjectContext);

export function ProjectProvider({ children }) {
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [selectedId, setSelectedId] = useState(localStorage.getItem("cs_project") || "");
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/projects");
      setProjects(data);
      if (data.length && !data.find((p) => p.id === selectedId)) {
        select(data[0].id);
      }
    } finally {
      setLoading(false);
    }
  };

  const select = (id) => {
    setSelectedId(id);
    localStorage.setItem("cs_project", id);
  };

  useEffect(() => {
    if (user) refresh();
    // eslint-disable-next-line
  }, [user]);

  const selected = projects.find((p) => p.id === selectedId) || null;

  return (
    <ProjectContext.Provider value={{ projects, selected, selectedId, select, refresh, loading }}>
      {children}
    </ProjectContext.Provider>
  );
}
